import { createRouteConfig } from 'modules/router/utils/createRouteConfig';

const OAUTH_PATH = '/oauth/';

export const oAuthRoutesConfig = createRouteConfig(
  {
    oAuth: {
      path: OAUTH_PATH,
      generatePath: () => OAUTH_PATH,
    },
  },
  OAUTH_PATH,
);
